/**
 * Shared lifecycle state for the HTTP layer.
 *
 * Kept in its own module to avoid circular imports between `start.ts` (which
 * imports `createApp` from `app.ts`) and consumers like `app.ts` or the
 * shutdown middleware. Only `start.ts` should toggle the flag.
 */

let _isShuttingDown = false

/** True once graceful shutdown has started (signal or programmatic stop). */
export function isShuttingDown(): boolean {
  return _isShuttingDown
}

/** Internal — only `start.ts` should toggle this. */
export function setShuttingDown(value: boolean): void {
  _isShuttingDown = value
}
